import { Datepicker } from "stimulus-datepicker"
import moment from "moment"

export default class extends Datepicker {
  static values = {
    ...Datepicker.values,
    allow: { type: Array, default: [] },
    allowUrl: { type: String, default: "" },
  }

  async connect() {
    super.connect()
    await this.fetchAllAllowDates()
    this.applyAllowList()
    this.dispatch("ready", { bubbles: true })
  }

  async fetchAllAllowDates() {
    const url = (this.allowUrlValue || "").trim()
    if (!url) return

    const res = await fetch(url, { headers: { Accept: "application/json" } })
    if (!res.ok) return

    const body = await res.json()
    const rows = body.booking_available_dates || body || []

    this.allowValue = rows
      .map((r) => r?.date)
      .filter(Boolean)
      .map((d) => moment(d).format("YYYY-MM-DD"))
  }

  applyAllowList() {
    const allow = (this.allowValue || []).filter(Boolean)
    if (allow.length === 0) return

    const allowSet = new Set(allow)
    const sorted = allow.slice().sort()

    this.minValue = sorted[0]
    this.maxValue = sorted[sorted.length - 1]

    const disallowSet = new Set()

    const start = new Date(`${this.minValue}T00:00:00`)
    const end = new Date(`${this.maxValue}T00:00:00`)

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const iso = d.toISOString().slice(0, 10)
      if (!allowSet.has(iso)) disallowSet.add(iso)
    }

    this.disallowValue = Array.from(disallowSet)
  }
}
